import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Spinner } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';
//icons
import { RiCloseLine } from 'react-icons/ri';

const CustomInput = React.forwardRef((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const fileInputRef = ref;
  const acceptFiles = props.accept ? {
    [props.accept]: []
  } : {};

  const onDrop = useCallback((acceptedFiles) => {
    props.onChange(acceptedFiles[0]);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptFiles,
    maxFiles: 1
  });

  const handleCloseFile = (e) => {
    props.onChange(undefined)
  }

  const truncateFileName = (fileName, maxLength = 15) => {
    if (fileName.length > maxLength) {
      const namePart = fileName.substring(0, maxLength - 3);
      const ext = fileName.split('.').pop();
      return `${namePart}...${ext}`;
    }
    return fileName;
  };

  const renderBody = () => {
    if (isLoading) {
      return <Spinner animation="border" size="sm" variant="light" />
    } else if (props.value && props.value.name) {
      const truncatedName = truncateFileName(props.value.name);
      return <p title={props.value.name} className='name-file'>
        {truncatedName}
      </p>
    } else {
      return <p title={props.placeholder}>{props.placeholder}</p>
    }
  };

  const handleKeyDown = (event) => {
    if (props.handleKeyDown && event.key === 'Enter') {
      event.preventDefault();
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, [props.value]);

  return (
    <Form.Group className="mt-0">
      {props.label && (
        <Form.Label className="text-light d-flex align-items-center">
          {props.label}
        </Form.Label>
      )}
      <div className="position-relative">
        {props.type === 'file' ? (
          <div className='file-container'>
            {props.value && <RiCloseLine onClick={handleCloseFile} />}
            <div {...getRootProps()} className={`custom-file-input input-control ${isDragActive ? 'drag-active' : ''} ${props.className || ''}`}>
              <Form.Control
                type="file"
                ref={fileInputRef}
                {...getInputProps()}
                isInvalid={props.error ? true : false}
              />
              {renderBody()}
            </div>
          </div>
        ) : (
          <Form.Control
            value={props.value}
            readOnly={props.readOnly}
            className={`input-control w-100 ${props.className || ''}`}
            disabled={props.disabled}
            type={props.type}
            ref={props.ref}
            placeholder={props.placeholder}
            title={props.title || props.placeholder}
            defaultValue={props.defaultValue}
            onChange={(e) => props.onChange(e.target.value)}
            min={props.type === 'number' ? props.min : ''}
            max={props.type === 'number' ? props.max : ''}
            isInvalid={props.error ? true : false}
            onInput={props.onInput}
            onKeyUp={props.onKeyPress}
            autoComplete={props.autoComplete ? "on" : "off"}
            step={props.step ? props.step : ''}
            onKeyDown={handleKeyDown}
            data-testid={props.dataTestId}
          />
        )}
        {props.icon && props.icon}
        <Form.Control.Feedback
          type="invalid"
          style={{ display: props.error ? 'block' : '' }}
        >
          {props.error}
        </Form.Control.Feedback>
      </div>
    </Form.Group>
  );
});

CustomInput.propTypes = {
  error: PropTypes.string,
  label: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
  onInput: PropTypes.func,
  onKeyPress: PropTypes.func,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  onClear: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  ref: PropTypes.object,
  autoComplete: PropTypes.bool,
  step: PropTypes.string,
  handleKeyDown: PropTypes.bool,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};

export default CustomInput;